import React from 'react';
import { Counter } from '../common/Counter';
import type { AiMatchAnalyticsItem } from '../../types/dashboard';
import { Tooltip } from '@radix-ui/themes';
import { InfoCircle } from 'iconoir-react';

interface AiMatchAnalyticsCardProps {
  item: AiMatchAnalyticsItem;
  bg: string;
  text: string;
  isLast: boolean;
}

const AiMatchAnalyticsCard = ({
  item,
  bg,
  text,
  isLast,
}: AiMatchAnalyticsCardProps) => {
  return (
    <div
      className={`sm:p-4 p-3 rounded-xl ${bg} text-center ${isLast ? 'col-span-2 md:col-span-1' : ''}`}
    >
      <h3 className={`!font-medium sm:!text-[2rem] !text-[1.75rem] ${text} mb-2`}>
        {item.percentage == null ? (
          // Jun-19: no AI-scored matches yet, show N/A instead of a misleading
          // 0% (Discover-origin matches carry no compatibility score).
          'N/A'
        ) : (
          <>
            <Counter value={item.percentage} />%
          </>
        )}
      </h3>
      {/* Apr-25: title InfoTip for metric explainer. Matches the
          pattern used by StatsCard on the top-row dashboard cards. */}
      <p className='!font-semibold text-body-400 text-xs mb-0 inline-flex items-center justify-center gap-1'>
        {item.title}
        {item?.info && (
          <Tooltip content={item.info}>
            <button
              type='button'
              className='inline-flex items-center justify-center focus:outline-none'
              aria-label={`About ${item.title}`}
            >
              <InfoCircle className='w-3.5 h-3.5 text-body-300 hover:text-body-500 transition-colors' />
            </button>
          </Tooltip>
        )}
      </p>
    </div>
  );
};

export default AiMatchAnalyticsCard;
